import { Component, Prop, Inject, Vue, Mixins } from 'vue-property-decorator'
import { Getter, Mutation } from 'vuex-class'
import { isString } from 'lodash'

import EventMixin from './event'
import ValidatorMixin from './validator'

@Component
export default class extends Mixins(EventMixin, ValidatorMixin) {
  @Getter('context/getVariable')
  getVariable!: (path: string) => any

  @Mutation('context/setVariable')
  setVariable!: (payload: { path: string, value: any }) => void

  @Prop({
    type: String,
    required: true,
    validator: (value: string) => !!value.length
  })
  name!: string

  @Prop({ type: Boolean, default: false })
  autofocus!: boolean

  @Prop({ type: [String, Boolean], default: false })
  disabled!: string | boolean

  @Prop({ type: String, default: '' })
  invalidFeedback!: string

  @Prop({ default: '' })
  default!: any

  @Inject()
  readonly register?: (component: Vue) => void

  @Inject()
  readonly deregister?: (component: Vue) => void

  get fieldPath () {
    return `fields.${this.name}`
  }

  get fieldValue () {
    return this.getVariable(this.fieldPath)
  }

  set fieldValue (value: any) {
    this.setVariable({ path: this.fieldPath, value })
    this.state = this.validate(value)
    this.broadcastEvents('change')
  }

  get computedDisabled () {
    let value = this.disabled
    if (isString(value)) {
      value = this.getVariable(value)
    }
    return !!value
  }

  mounted () {
    // register with parent form component
    this.register && this.register(this)

    // check if the widgets field value is already filled and trigger change events
    if (this.fieldValue) {
      this.state = this.validate(this.fieldValue)
      this.broadcastEvents('change')
    }
  }

  beforeDestroy () {
    // unregister
    this.deregister && this.deregister(this)
  }

  /**
   * Reset the value and state of the widget.
   */
  reset () {
    this.setVariable({ path: this.fieldPath, value: this.default })
    this.state = null
  }
}
